import React, {Component} from 'react';
import './TeachersSlides.scss';
import Slider from "react-slick";
import {Card, CardBody, Row, Col} from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Button} from "reactstrap";
import * as constants from "../../const/constants";
import TeacherImg from '../.././assets/img/revamp/teacherImg.png'

import {lang, language} from "../../const/language";
import * as actionCreator from "../../store/domain/classes/action";
import * as actionSpinnerCreator from "../../store/domain/spinner/action";
import * as actionModalCreator from "../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";

class TeacherTile extends Component {

    state={
        screenSize:1440
    };

    viewLectureHandler = (object) => {
        console.log(object);
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_TEACHER_ROUTE}/${object.urlName}`,
            state: object
        })
    };

    componentDidMount() {
        this.setState({screenSize: window.innerWidth});
    }

    render() {
        let {teacher} = this.props;
        let {screenSize} = this.state;
        return (
            <Col sm={12} md={ screenSize > 768 ? 4 :6} lg={3} xl={3}>
                <div className={"teachers-slide-show"}>
                    <div key={teacher.teacherId}>
                        <div
                            className={`border-0 card`}>
                            <div className={"display-inline "}>
                                {/*<img src={TeacherImg} alt={"."}*/}
                                {/*     className={"blur-img"}/>*/}
                                <img   onClick={() => this.viewLectureHandler(teacher)} src={teacher.imageUrl ? teacher.imageUrl :TeacherImg} alt={"."}
                                     className={"slideshow-pro-image shadow"}/>

                                <div className={"slideshow-middle"}>
                                    <div className={"cursor minHeight"}>
                                        <div onClick={() => this.viewLectureHandler(teacher)}>
                                            <h4 className={"topic"}>{teacher.name}</h4>

                                            <Row className={"card-row"}>
                                                <Col xs="12"><p className={"qualification"}>{teacher.qualification} </p>
                                                </Col>
                                            </Row>
                                            <Row className={"card-row"}>
                                                <Col xs="12"><p className={"description"}>{teacher.description} </p>
                                                </Col>
                                            </Row>
                                        </div>

                                        <div className={"btn-ctrl"}>
                                            <Button className='btn-moreDetails-name'
                                                    onClick={() => this.viewLectureHandler(teacher)}>
                                                {language[lang].aboutTeacher}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        )
    }
};


const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    lecturer: state.lecturer.lecturer,
    userObj: state.student.userObj
});

const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TeacherTile));
